import { FaTimes, FaEdit } from 'react-icons/fa'
import { useContext } from 'react'
import ResultContext from '../context/ResultContext'
import { useNavigate } from 'react-router-dom'

function ResultItem({ item }) {
  const { deleteCard, editInventory } = useContext(ResultContext)

  const navigate = useNavigate()

  const cardClick = (e) => {
    console.log(item.id)
    navigate(`/inventory/${item.id}`)
  }

  const buttonClick = (e) => {
    e.stopPropagation()
    navigate(`/contact`)
  }

  return (
    <>
      <div
        className='card m-1 max-w-screen b-4 border hover:border-gray-200 hover:shadow-2xl'
        onClick={cardClick}
        style={{ cursor: 'pointer' }}
      >
        <figure>
          <img
            src={item.image}
            alt=''
            className='object-none object-center object-fit'
          />
        </figure>

        <div className='p-3'>
          <span className='flex flex-row justify-between'>
            <h2 className='text-sm mb-1 font-medium'>{item.color}</h2>
            <span className=''>
              {/* <button className='mr-2' onClick={() => editInventory(item)}>
                <FaEdit color='orangered' />
              </button>
              <button className='' onClick={() => deleteCard(item.id)}>
                <FaTimes color='firebrick' />
              </button> */}
            </span>
          </span>
          <p className='text-sm mb-1'>{item.brand}</p>
          <p className='text-sm mb-2'>
            Size: {item.length}" x {item.width}"
          </p>
          <div className='card-actions justify-end'>
            {/* <button className='btn btn-sm btn-outline btn-primary text-xs'>
                {item.type}
              </button>
              <button className='btn btn-sm btn-outline btn-info text-xs'>
                {item.tag}
              </button> */}

            <button
              className='btn btn-sm btn-outline btn-success text-xs'
              onClick={buttonClick}
            >
              Buy Now
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ResultItem
